import config from '@/config'
import Comments, { IComments } from '@/models/Comments'
import { useGlobalStore } from '@/store/app'
import BaseService from './BaseService'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

const http = requests(config?.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('groupId')
class CommentsServiceCls extends BaseService<Comments> {
  constructor() {
    super(null as any)
  }

  model() {
    return Comments
  }

  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/${appStore.locationId}/groups/${appStore.groupId}`
  }

  async create(data: IComments): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/posts/${data.postId}/comments`,
      data
    )
    return response?.data
  }

  async updateComment(
    commentData: IComments,
    postId: string,
    commentId: string
  ): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/posts/${postId}/comments/${commentId}`,
      {
        action: 'UPDATE_COMMENT',
        comment: commentData,
      }
    )
    return response.data
  }

  async fetchComments(postId: string, query?: any): Promise<any> {
    const response = await http.get(
      `${this.endpoint}/posts/${postId}/comments`,
      { params: query }
    )
    return response.data
  }

  async fetchCommentById(postId: string, commentId: string): Promise<any> {
    const response = await http.get(
      `${this.endpoint}/posts/${postId}/comments/${commentId}`
    )
    return response.data
  }

  async deleteComment(
    commentId: string,
    postId: string,
    parentId?: string
  ): Promise<any> {
    const response = await http.delete(
      `${this.endpoint}/posts/${postId}/comments/${commentId}`,
      {
        params: {
          parentId: parentId,
        },
      }
    )
    return response.data
  }
}

// Export singleton instance
export const CommentsService = new CommentsServiceCls()

// Export type for dependency injection
export type ICommentsService = CommentsServiceCls

// Export commonly used methods directly
export const {
  create,
  updateComment,
  fetchComments,
  fetchCommentById,
  deleteComment,
} = CommentsService
